import { createContext } from '../../utils/createContext';
var _a = createContext(), context = _a[0], useContext = _a[1];
export var RadioContext = context;
export var useRadioContext = useContext;
//# sourceMappingURL=context.js.map